module.exports = __webpack_public_path__ + "img/Icon-Close-red.222dbc69.svg";